import {I18n} from 'react-redux-i18n';
import {replace, capitalize, trim, startCase} from 'lodash';

const accelerometersEventsGeotab = [
  'ruleHarshbrakingid',
  'rulejackrabbitstartsid',
  'ruleharshcorneringid',
  'ruleaccidentid'
];

const mappingEvents = {
  ruleHarshbrakingid: 'Sudden Stop',
  rulejackrabbitstartsid: 'Sudden Start',
  ruleharshcorneringid: 'Harsh Turn',
  ruleaccidentid: 'Possible Collision'
};

const formatOERLabel = eventId => {
  let eventName = `${I18n.t(`filter.oer.${eventId}`)}`;

  if (accelerometersEventsGeotab.includes(eventName)) {
    eventName = mappingEvents[eventName];
  } else if (eventName === eventId) {
    eventName = trim(capitalize(startCase(replace(eventId, new RegExp('_', 'g'), ' '))));
  }

  return eventName;
};

export default formatOERLabel;
